import { observer } from 'mobx-react-lite';
import { useComputed } from 'owa-react-hooks/lib/useComputed';
import {
    showMoreCalendarsContextMenu,
    showLessCalendarsContextMenu,
    newCalendarGroupString,
    accountSettings,
} from '../strings.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import {
    ContextualMenu,
    IContextualMenuItem,
    DirectionalHint,
} from '@fluentui/react/lib/ContextualMenu';
import type ContextMenuViewState from '../store/schema/ContextMenuViewState';

export interface CalendarAccountGroupContextMenuProps {
    contextMenuViewState: ContextMenuViewState | null;
    isCondensed: boolean;
    onAccountSettings: () => void;
    onDismiss: (ev?: any) => void;
    onShowMoreOrLess: () => void;
    onNewCalendarGroup: () => void;
}

export default observer(function CalendarAccountGroupContextMenu(
    props: CalendarAccountGroupContextMenuProps
) {
    const contextMenuItems = useComputed((): IContextualMenuItem[] => {
        const { isCondensed, onAccountSettings, onShowMoreOrLess, onNewCalendarGroup } = props;
        let menuItems: IContextualMenuItem[] = [];
        if (onAccountSettings) {
            menuItems.push({
                key: 'Account_settings',
                name: loc(accountSettings),
                onClick: onAccountSettings,
            });
        }
        return menuItems.concat([
            {
                key: isCondensed ? 'show_more' : 'show_less',
                name: isCondensed
                    ? loc(showMoreCalendarsContextMenu)
                    : loc(showLessCalendarsContextMenu),
                onClick: onShowMoreOrLess,
            },
            {
                key: 'new_calendar_group',
                name: loc(newCalendarGroupString),
                onClick: onNewCalendarGroup,
            },
        ]);
    });
    const { contextMenuViewState, onDismiss } = props;
    return contextMenuViewState ? (
        <ContextualMenu
            items={contextMenuItems.get()}
            target={contextMenuViewState.anchorElement}
            directionalHint={DirectionalHint.bottomLeftEdge}
            onDismiss={onDismiss}
        />
    ) : null;
});
